import * as React from "react"
import {Box, Typography} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

import {useMatchersAttributes} from "../../@hooks";
import SkuAttributesTable from "./AttributeTable";
import SkuAttributesLoadingBlock from "./LoadingBlock";


export default function SkuAttributesBlock({ skuID=null, productID=null, siteID=null }) {
	const { isLoading, showAttrs, attributes, handleClick } = useMatchersAttributes(skuID, productID, siteID)

	return <Box display="flex" flexDirection="column" gap={2} width={1}>
		<Box display="flex" gap={1} sx={{ cursor: 'pointer' }} onClick={handleClick}>
			<IconSeeker icon={showAttrs ? 'eye-slash' : 'circle-info'} />
			<Typography variant="caption">
				{ showAttrs ? "Click to hide attributes" : "Click to see attributes" }
			</Typography>
		</Box>

		{ isLoading
			? <SkuAttributesLoadingBlock  />
			: <SkuAttributesTable show={showAttrs} attributes={attributes}/> }
	</Box>
}